import React from 'react';
import './assets/css/App.css';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import theme from './theme/theme';
import { store } from './store/store';
import AdminLayout from './layouts/admin';
import SignIn from './views/auth/signIn';

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
	<Provider store={store}>
		<ChakraProvider theme={theme}>
			<React.StrictMode>
				<HashRouter>
					<Routes>
						<Route index element={<AdminLayout />} />
						<Route path='auth' element={<SignIn />} />
						<Route path='admin/*' element={<AdminLayout />} />
						<Route path='*' element={<AdminLayout />} />
					</Routes>
				</HashRouter>
			</React.StrictMode>
		</ChakraProvider>
	</Provider>
);
